export default __webpack_public_path__ + "media/images/44-5d10d4334e80acb055488ba83ec4cb10.png";